import { SettlementsOrAdvancesPage } from "./agtechSettlementsOrAdvances/SettlementsOrAdvancesPage";
import { useListAgtechAdvances } from "@/lib/api/agtech/ticketsExpanded";

export function AgtechAdvancesPage() {
  return <SettlementsOrAdvancesPage type="advances" useListHook={useListAgtechAdvances} />;
}
